import { render } from "./App.vue?vue&type=template&id=ce10c86a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ce10c86a&lang=scss"

import exportComponent from "D:\\工作空间\\xx-fds-protal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__